export const environment = {
    production: false,
    api: "https://app-device-service-portal-api-dev-001.azurewebsites.net/api/",//"https://localhost:7071/api/",
    recaptcha: {
      siteKey: "6LeQuKkeAAAAALtqD6HmQZ1px3OaEZRispZRf3ks"
    }
  };
  